import { MARQUEE } from "@/data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display text-2xl sm:text-4xl px-5 sm:px-8 ${i % 2 ? "text-[#FF5A5F]" : "text-[#1B1530]"}`}>{w}</span>
        <svg viewBox="0 0 24 24" className="h-6 w-6 sm:h-7 sm:w-7 fill-[#1B1530]"><path d="M12 2c1.6 3.6 3.4 5.4 7 7-3.6 1.6-5.4 3.4-7 7-1.6-3.6-3.4-5.4-7-7 3.6-1.6 5.4-3.4 7-7z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="overflow-x-clip">
    <div data-testid="editorial-marquee-bar" className="relative bg-[#3EE6FF] py-5 sm:py-7 overflow-hidden -rotate-1 scale-[1.03]">
      <div className="marquee-track flex w-max"><Row /><Row /></div>
    </div>
  </div>
);
